import { Collapse, IconButton, Typography } from '@material-ui/core'
import Checkbox from '@material-ui/core/Checkbox'
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown'
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp'
import React, { useEffect, useState } from 'react'

import { getTranslate, lang } from '../../localization'
import { Channel } from '../../types/channel'
import { UserBrief } from '../../types/users'
import useStyles from './styles/channelList.styles'

interface ChannelListRowHeaderProps {
  channel: Channel
  filteredUserList: UserBrief[] | undefined
  setUsers: React.Dispatch<React.SetStateAction<UserBrief[]>>
  users: UserBrief[]
}
const ChannelListRowHeader: React.FC<ChannelListRowHeaderProps> = ({
  channel,
  filteredUserList,
  setUsers,
  users
}) => {
  const classes = useStyles()
  const [isExpanded, setIsExpanded] = useState<boolean>(false)
  const [checkedHeader, setCheckedHeader] = useState<boolean>(false)

  const [newFilteredUserList, setNewFilteredUserList] = useState<UserBrief[]>(
    []
  )

  useEffect(() => {
    if (filteredUserList) setNewFilteredUserList(filteredUserList)
  }, [channel, filteredUserList])

  const [selectAllProps, setSelectAllProps] = useState<{
    checked: boolean
    indeterminate: boolean
  }>()

  const handleClickOnArrowIcon = () => {
    setIsExpanded(!isExpanded)
  }

  const allSelected = newFilteredUserList.every(
    (item: any) => item.checked === true
  )

  const handleClickedCheckboxHeader = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setCheckedHeader(event.target.checked)
    if (allSelected) {
      setNewFilteredUserList((currentList: any) =>
        currentList.map((item: any) => ({ ...item, checked: false }))
      )
    } else {
      setNewFilteredUserList((currentList: any) =>
        currentList.map((item: any) => ({ ...item, checked: true }))
      )
    }
  }

  useEffect(() => {
    if (
      newFilteredUserList &&
      newFilteredUserList.length > 0 &&
      users.length > 0
    ) {
      setSelectAllProps({
        checked: allSelected,
        indeterminate:
          !allSelected &&
          newFilteredUserList.some((user) => user.checked === true)
      })
    }
  }, [checkedHeader, newFilteredUserList])

  const addUserFunc = (index: number) => {
    if (newFilteredUserList[index].checked === false) {
      setUsers([...users, newFilteredUserList[index]])
    } else {
      setUsers(
        users.filter((user) => user.ID !== newFilteredUserList[index].ID)
      )
    }
  }

  const addUserFuncAllTogether = () => {
    if (allSelected) {
      const IDs = newFilteredUserList.map((filterUser) => filterUser.ID)
      setUsers(users.filter((user) => !IDs.includes(user.ID)))
    } else {
      const tempUsers = [...users]
      newFilteredUserList.forEach((filterUser) => {
        if (!users.find((user) => user.ID === filterUser.ID)) {
          tempUsers.push(filterUser)
        }
      })
      setUsers(tempUsers)
    }
  }

  useEffect(() => {
    if (users.length === 0) {
      setCheckedHeader(false)
      setSelectAllProps({
        checked: false,
        indeterminate: false
      })
      if (filteredUserList) {
        setNewFilteredUserList([
          ...filteredUserList.map((item: UserBrief) => ({
            ...item,
            checked: false
          }))
        ])
      }
    }
  }, [users])

  return (
    <>
      <div>
        <div className={classes.header}>
          <Checkbox
            color="primary"
            checked={checkedHeader}
            onChange={(event) => {
              handleClickedCheckboxHeader(event)
              addUserFuncAllTogether()
            }}
            {...selectAllProps}
          />
          {/* Same split as the user name/email below: 'Channel' is a UI word and IS
              translated; the channel's own code and name are DATA and are not. They were
              being passed to getTranslate inside template literals that also carried a
              stray leading/trailing space, so the lookup key was e.g. "SNAPP " — it only
              ever missed by luck, and a channel named after a dictionary key would have
              rendered as that key's translation instead of its own name. */}
          <Typography variant="h4" className={classes.channelName}>
            {lang === 'en'
              ? `${channel.basicDetails.displayChannelCode} ${getTranslate(
                  'Channel'
                )}`
              : `${getTranslate('Channel')} ${channel.basicDetails.name}`}
          </Typography>
          <IconButton
            className={classes.arrowIconContainer}
            onClick={handleClickOnArrowIcon}>
            {!isExpanded ? <KeyboardArrowDownIcon /> : <KeyboardArrowUpIcon />}
          </IconButton>
        </div>
        <div className={classes.body}>
          {newFilteredUserList.map((user, index) => (
            <Collapse in={isExpanded} timeout={500} key={index}>
              <div className={classes.providerRow}>
                <Checkbox
                  color="primary"
                  className={classes.userCheckbox}
                  checked={user.checked}
                  onChange={() => {
                    setNewFilteredUserList?.([
                      ...newFilteredUserList.slice(0, index),
                      {
                        ...newFilteredUserList[index],
                        checked: !user.checked
                      },
                      ...newFilteredUserList.slice(index + 1)
                    ])
                    addUserFunc(index)
                  }}
                  disabled={!user.active}
                />
                {/* A person's name and email are DATA, not dictionary keys. getTranslate
                    returns `translate[lang][text] || text`, so a user called "Active" or
                    "Save" renders as فعال / ذخیره — their own name replaced by an unrelated
                    UI string, silently and only in Persian. Names that match nothing render
                    correctly, which is why this survived: it only misfires on the subset of
                    people whose name collides with a key. */}
                <Typography variant="h5" className={classes.channelName}>
                  {user.name}
                </Typography>
                <Typography variant="h5" className={classes.emailContainer}>
                  {user.email}
                </Typography>
              </div>
            </Collapse>
          ))}
        </div>
      </div>
    </>
  )
}

export default ChannelListRowHeader
